import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import shareModal from './ShareModal.module.css'
import ShareBtn from '../../Assets/share-file.svg';
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";

export const ShareModal = ({ shareUrl }) => {
  const isMobile = window.screen.width < 769;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState("Anyone in the Company");

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setPrivacy('Anyone in the Company');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPrivacy('Anyone in the Company');
  };

  return (
    <>
      <Tooltip title='Share document'>
        <div onClick={showModal} style={{ cursor: "pointer", zIndex: 1 }} >
          <img className={shareModal.sharebtn} src={ShareBtn} style={{ height: isMobile ? "22px" : "30px", position: "relative", top: isMobile ? '3px' : '' }} />
        </div>
      </Tooltip>
      <Modal
        title="Share with People"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
      >
        <ShareModalContent shareUrl={shareUrl} setIsModalVisible={setIsModalVisible} privacy={privacy} setPrivacy={setPrivacy} />
      </Modal>
    </>
  );
};
